import { UserRolesBulkActions } from "./types";

export const BULK_ACTION_RESULTS_TITLE: Record<UserRolesBulkActions, string> = {
  [UserRolesBulkActions.Delete]: "Unassign user roles results",
};

export const BULK_ACTION_NAMES: Record<UserRolesBulkActions, string> = {
  [UserRolesBulkActions.Delete]: "Unassign",
};
